<div class="item user-block" *ngIf="userBlockIsVisible()">
  <div>
    <img class="img-fluid" sizes="100%" src="assets/img/logo/AGAT.logo.air.png" alt="AGAT" />
  </div>
</div>
